let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ephaU")).then(() => parcelRequire('e4lFW'));